export const REMOVE_PASSENGER_SSR = 'REMOVE_PASSENGER_SSR'

export default (passengerId: string, passengerSSRId: string) => ({
  type: REMOVE_PASSENGER_SSR,
  passengerId,
  passengerSSRId,
})
